import {Component, Inject, signal, WritableSignal} from '@angular/core';
import {WidgetDataTable, WidgetTrend} from '../../models/dashboard';
import {NgIf} from '@angular/common';

@Component({
    selector: 'app-widget-template-trend',
    imports: [
        NgIf
    ],
    templateUrl: './widget-template-trend.component.html',
    styleUrl: './widget-template-trend.component.css',
    standalone: true
})
export class WidgetTemplateTrendComponent {
  widgetHeader: WritableSignal<string> = signal('');
  data;

  constructor(@Inject('contentData') public contentData: any, @Inject('label') public label: string) {
    this.data = signal<WidgetTrend>(JSON.parse(this.contentData));
    this.widgetHeader.set(this.label);
  }
}
